export default "/fonts/vendor/katex/dist/KaTeX_Typewriter-Regular.ttf?c5c02d763c89380dcb4ed359e15d0897";